module.exports = __webpack_public_path__ + "img/all-in-one.505e5161.jpg";